// @flow
import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Avatar, Card, Box, Text } from 'gestalt';

type Props = {
  credits: {
    link: ?string,
    creditText: string,
    thumbnailAlt: string,
    thumbnailSrc: string,
  },
  onMouseEnter: Function,
  onMouseLeave: Function,
};

export default function Credits(props: Props) {
  const {
    credits: { creditText, link, thumbnailAlt, thumbnailSrc },
    onMouseEnter,
    onMouseLeave,
  } = props;

  return (
    <Card>
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <Box deprecatedPadding={{ y: 1 }} deprecatedMargin={{ top: 2 }}>
          <NavigateLink className="creditsCard" to={link}>
            <Box display="flex">
              <Box display="flex" alignItems={'center'} deprecatedMargin={{ right: 1 }}>
                <div className="creditsImage">
                  <Avatar src={thumbnailSrc} name={thumbnailAlt} />
                </div>
              </Box>
              <Box>
                <Text size="xs" smSize="xs" mdSize="xs" lgSize="xs">
                  {creditText}
                </Text>
              </Box>
            </Box>
          </NavigateLink>
        </Box>
      </div>
    </Card>
  );
}
